(function () {
  var root = document.querySelector('.rgp');
  if (!root) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Apparition au scroll */
  var rv = root.querySelectorAll('[data-rv]');
  if ('IntersectionObserver' in window && !reduce) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { threshold: 0.12 });
    rv.forEach(function (el) { io.observe(el); });
  } else { rv.forEach(function (el) { el.classList.add('is-in'); }); }

  /* Afficheur à palettes : NOVEMBRE */
  var AZ = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  root.querySelectorAll('[data-flap]').forEach(function (el) {
    var word = el.getAttribute('data-flap'), cells = [];
    for (var i = 0; i < word.length; i++) { var b = document.createElement('b'); b.textContent = word[i]; el.appendChild(b); cells.push(b); }
    if (reduce) return;
    function run() {
      cells.forEach(function (c, i) {
        var n = 0, max = 6 + i * 3;
        var t = setInterval(function () {
          n++;
          if (n >= max) { c.textContent = word[i]; clearInterval(t); }
          else { c.textContent = AZ[Math.floor(Math.random() * 26)]; }
        }, 55);
      });
    }
    setTimeout(run, 700);
    setInterval(run, 10000);
  });

  /* Grattez la mousse */
  var box = root.querySelector('[data-scratch]');
  if (!box) return;
  var cv = box.querySelector('canvas'), ctx = cv.getContext('2d');
  var sec = document.getElementById('rgp-reveal');
  var before = sec.querySelector('.rgp-before'), after = sec.querySelector('.rgp-after');
  var done = false, moves = 0, drawing = false, last = null;

  function paint() {
    var r = box.getBoundingClientRect(), d = window.devicePixelRatio || 1, w = r.width, h = r.height;
    cv.width = w * d; cv.height = h * d; ctx.setTransform(d, 0, 0, d, 0, 0);
    ctx.globalCompositeOperation = 'source-over';
    ctx.fillStyle = '#f3f3f0'; ctx.fillRect(0, 0, w, h);
    var seed = 11;
    function rnd() { seed = (seed * 9301 + 49297) % 233280; return seed / 233280; }
    for (var i = 0; i < 280; i++) {
      var x = rnd() * w, y = rnd() * h, rad = 4 + rnd() * rnd() * 52;
      ctx.beginPath(); ctx.arc(x, y, rad, 0, Math.PI * 2);
      ctx.fillStyle = 'rgba(255,255,255,' + (0.55 + rnd() * 0.45) + ')'; ctx.fill();
      ctx.lineWidth = 1; ctx.strokeStyle = 'rgba(4,30,66,' + (0.05 + rnd() * 0.1) + ')'; ctx.stroke();
      ctx.beginPath(); ctx.arc(x - rad * 0.35, y - rad * 0.35, rad * 0.16, 0, Math.PI * 2);
      ctx.fillStyle = 'rgba(255,255,255,.95)'; ctx.fill();
    }
    ctx.fillStyle = '#111'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
    ctx.font = '900 ' + Math.round(w / 13) + 'px ' + (getComputedStyle(root).getPropertyValue('--rgp-font') || 'sans-serif');
    ctx.fillText('GRATTEZ LA MOUSSE', w / 2, h / 2);
  }
  paint();
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { if (!done && moves === 0) paint(); });
  window.addEventListener('resize', function () { if (!done && moves === 0) paint(); });

  function pos(e) { var r = cv.getBoundingClientRect(); return { x: e.clientX - r.left, y: e.clientY - r.top }; }
  function check() {
    var w = cv.width, h = cv.height, data = ctx.getImageData(0, 0, w, h).data, step = 24, clear = 0, total = 0;
    for (var y = 0; y < h; y += step) for (var x = 0; x < w; x += step) { total++; if (data[(y * w + x) * 4 + 3] < 40) clear++; }
    if (clear / total > 0.45) reveal();
  }
  function scratch(p) {
    ctx.globalCompositeOperation = 'destination-out';
    ctx.lineCap = 'round'; ctx.lineJoin = 'round'; ctx.lineWidth = Math.max(38, box.clientWidth / 8);
    ctx.beginPath(); ctx.moveTo(last ? last.x : p.x, last ? last.y : p.y); ctx.lineTo(p.x + 0.1, p.y); ctx.stroke();
    last = p;
    if (++moves % 10 === 0) check();
  }
  function reveal() {
    if (done) return;
    done = true; box.classList.add('is-done');
    before.hidden = true; after.hidden = false;
  }
  cv.addEventListener('pointerdown', function (e) { drawing = true; last = null; try { cv.setPointerCapture(e.pointerId); } catch (err) {} scratch(pos(e)); });
  cv.addEventListener('pointermove', function (e) { if (drawing) scratch(pos(e)); });
  ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (t) { cv.addEventListener(t, function () { drawing = false; last = null; }); });
  var all = sec.querySelector('[data-reveal-all]');
  if (all) all.addEventListener('click', reveal);
})();